import React, { useState, useEffect, Fragment } from "react";
import { toast } from "react-toastify";
import containerImage from "../../../../assets/images/orderManagementnonideal.png";
import {
  AppAlertBar,
  AppPagination,
  ParagraphText,
  UBButton,
} from "../../../../Libraries";
import { AppNonIdeal, FilterNonIdeal, PopoverMenu } from "../../../common";
import ReturnListItem from "./ReturnListItem";
import OrderListItem from "./OrderListItem";
import { Box, CircularProgress } from "@mui/material";
import HeaderItem from "./HeaderItem";
import { handleApi } from "../../../../apis";
import {
  PATCH_BULK_ORDER_STATUS,
  DOWNLOAD_BULK_ORDERS,
  AIRWAY_BILL_INVOICE,
} from "../../../../apis/configuration";

import { analytics, triggerLogEvent } from "../../../../config/firebase";
import { useNavigate } from "react-router-dom";
import fileDownload from "js-file-download";
import AppTableFilters from "../../../common/AppTableFilters";
import { statusColor, TABLE_FILTERS_ORDER_MANAGEMENT } from "../../../../constants";
import { buildFiltersConfig } from "../../../../utils";
import styles from "./styles.module.css";
import { DownNewIcon, PrintIcon, TickIcon } from "../../../../assets/icons/icon";

const OrderList = ({ data }) => {


  const {
    handleOrderStatus,
    handlePagination,
    handleGetOrder,
    returnLoad,
    returnList,
    updateLoad,
    orderList,
    orderListParams,
    returnListParams,
    pageLoad,
    setSelectedStatus,
    searchLoad,
    toggleChatWidget,
    handleOrderStatusList,
    I18n,
    filters,
    appliedChips,
    handleFilterChange,
    resetFilters,
    handleRemoveChip,
    isResetFilter,
    setIsResetFilter,
    isOrderList,
    offset,
    setOffset,
    formattedDateFilter,
    isAppliedFilter
  } = data || {};
  const [orderToDownload, setOrderToDownload] = useState({});
  const [showProcessAlert, setShowProcessAlert] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState({
    bill: false,
    loadsheet: false,
    filters: false,
  });
  const [orderFilters, setOrderFilters] = useState({
    order_status: null,
    start_date: null,
    end_date: null,
  });
  const navigate = useNavigate();
  const { rejectReasons, orderStatuses, totalOrders } =
    isOrderList ? orderListParams : returnListParams;
  const { ready_to_ship, pending, delivered, accepted } = orderStatuses || {};
  const list = (isOrderList ? orderList : returnList) || {};


  /**
   * Receive params of id and list to select and deselect items in list individually or all
   * @returns Items to download
   */
  const handleSelection = (selectionObj = {}, fromHeader = false) => {

    if (fromHeader) {
      if (list.length != Object.keys(orderToDownload).length) {
        setOrderToDownload((prev) => {
          let all = { ...prev };
          list.map(
            (val) =>
            (all[val.id] = {
              download: true,
              id: val.id,
              tracking_id: val?.tracking_id,
              order_status: val?.order_status,
            }),
          );
          return all;
        });
      } else setOrderToDownload({});
    } else {
      setOrderToDownload((prev) => {
        let all = { ...prev };
        if (all[selectionObj.id]) delete all[selectionObj.id];
        else
          all[selectionObj.id] = {
            download: true,
            id: selectionObj?.id,
            tracking_id: selectionObj?.tracking_id,
            order_status: selectionObj?.order_status,
          };
        return all;
      });
    }
  };

  const handleLoading = () =>
    setLoadingDownload({ bill: false, loadsheet: false });


  /**
   * dropdown option selection, highlighting colord items in case of invalid selection on the basis of selected value
   */
  const onSelectOption = (key, value, subValue) => {
    if (key == I18n.mark_as) {
      setSelectedStatus(value?.statusValue);
      let params = { order_ids: orderToDownload };
      const compareOrders =
        value?.statusValue == "accepted"
          ? Object.values(orderToDownload).every(
            (item) => item.order_status == "pending",
          )
          : Object.values(orderToDownload).every(
            (item) => item.order_status == "accepted",
          );

      if (compareOrders) {
        value?.statusValue == "accepted"
          ? (params["accept"] = true)
          : (params["ready_to_ship"] = true);
        handlebulkOrderStatus(params, value?.statusValue);
      } else {
     
        toast.error(
          value?.statusValue == "accepted"
            ? "Only pending orders can be accepted"
            : "Only accepted orders can be shipped",
          { className: "errorToast" },
        );
        clearMarkedOrders()
      }
    } else if (key == I18n.order_status) {
      setOrderFilters({ ...orderFilters, order_status: value?.statusValue });
    }
  };

  /**
   * Calling bulk update status api and show order processing alert
   */
  const handlebulkOrderStatus = async (apiParams, type) => {
    if (type === "accepted") {
      triggerLogEvent(analytics, "sc_order_accept", {
        order_ids: apiParams.order_ids,
      });
    }
    if (type === "rejected") {
      triggerLogEvent(analytics, "sc_order_reject", {
        order_ids: apiParams.order_ids,
      });
    }

    handleOrderStatus(PATCH_BULK_ORDER_STATUS, apiParams, false, true).then(
      () => {
        if (type == "ready_to_ship") {
          setShowProcessAlert(true);
          setTimeout(() => setShowProcessAlert(false), 3000);
        }
        toast.success("Order status updated successfully", {
          className: "successToast",
        });
        setSelectedStatus(undefined);
        clearMarkedOrders();
      },
    );
  };

  // statusColor[status]



  /**
   * Calling search api and removing list to publish items if exist
   */
  const bulkApiPdfFunc = async (type, apiParams) => {
    try {
      const res =
        type == "bill"
          ? await handleApi(AIRWAY_BILL_INVOICE, apiParams, null, navigate, null, { responseType: "blob" })
          : await handleApi(DOWNLOAD_BULK_ORDERS, apiParams, null, navigate, null, { responseType: "blob" });
      fileDownload(res, type === "bill" ? "Airways.pdf" : "Loadsheet.pdf");
      toast.success(
        type == "bill"
          ? "Airway downloaded successfully"
          : "Loadsheet downloaded successfully",
        { className: "successToast" },
      );
      setOrderToDownload({});
    } catch (err) {
      toast.error(err?.response?.data?.message || "Something went wrong", {
        className: "errorToast",
      });
    } finally {
      handleLoading();
    }
  };

  /**
   * Calling an api to download on the basis of input selection
   * @returns succcess or error of download orders
   */
  const handleBulkOrderDownload = async (type) => {
    if (type === "bill") {
      triggerLogEvent(analytics, "sc_order_print_bill", {
        order_count: Object.keys(orderToDownload).length,
      });
    } else {
      triggerLogEvent(analytics, "sc_order_print_loadsheet", {
        order_count: Object.keys(orderToDownload).length,
      });
    }
    let params = {
      order_ids: Object.keys(orderToDownload),
    };
    if (type == "bill") {
      params["return"] = false;
      const hasTrackingId = Object.values(orderToDownload).every(
        (item) => item.tracking_id !== undefined && item.tracking_id !== null,
      );
      if (hasTrackingId) {
        setLoadingDownload({ ...loadingDownload, bill: true });
        bulkApiPdfFunc(type, params);
      } else {
        toast.error(
          "Some orders might not have their tracking id to download",
          { className: "errorToast" },
        );
      }
    } else {
      setLoadingDownload({ ...loadingDownload, loadsheet: true });
      bulkApiPdfFunc(type, params);
    }
  };


  const clearMarkedOrders = () => {
    setOrderToDownload({});
  };



  const Loader = () => {
    return (
      <div className="orderLoaderMain">
        <CircularProgress size={24} className="loaderCircle" />
      </div>
    );
  };

  const balance = [
    {
      title: isOrderList ? I18n.ready_to_ship : I18n.order_accepted,
      count: isOrderList ? ready_to_ship || 0 : accepted || 0,
    },
    {
      title: I18n.order_pending,
      count: pending || 0,
    },
    {
      title: I18n.order_delivered,
      count: delivered || 0,
    },
  ]
  const customButtons = [
    {
      id: "order_list_print_loadsheet_btn",
      disabled: Object.values(orderToDownload).length
        ? false
        : true,
      loading: loadingDownload.loadsheet,
      action: () => handleBulkOrderDownload("loadsheet"),
      title: I18n.print_loadsheet,
      className: styles.printButton,
      iconComponent: <PrintIcon />,
      spinnerColor: "newFontColor",

    },
    {
      id: "order_list_print_bill_btn",
      disabled: Object.values(orderToDownload).length
        ? false
        : true,
      loading: loadingDownload.bill,
      action: () => handleBulkOrderDownload("bill"),
      title: I18n.print_bill,
      className: styles.printButton,
      iconComponent: <PrintIcon />,
      spinnerColor: "newFontColor",
    },
  ]

  const status = Object.entries(orderStatuses || {}).map(
    ([key]) => ({
      label: I18n[key],
      value: key,
    }),
  )
  const customView = [{ label: I18n.orders, value: "orders" }, { label: I18n.returns, value: "returns" }]

  return (
    <>
      {showProcessAlert && (
        <AppAlertBar description={"Processing your orders"} />
      )
      }
      <Box className={"AccountWrapper"}>
        <AppTableFilters
          filters={TABLE_FILTERS_ORDER_MANAGEMENT}
          onFilterChange={handleFilterChange}
          appliedChips={appliedChips}
          filterState={filters}
          onRemoveChip={(chip) => handleRemoveChip(chip)}
          filtersConfig={buildFiltersConfig(TABLE_FILTERS_ORDER_MANAGEMENT, [], status, null, null, null, null, customView, "sort", I18n)}
          isResetFilter={isResetFilter}
          setIsResetFilter={setIsResetFilter}
          children={
            isOrderList && <Box className={styles.customButtonWrap}>
              {
                customButtons.length > 0 ?
                  customButtons.map(item => (
                    <UBButton
                      id={item.id}
                      title={item.title}
                      onClick={item.action}
                      disabled={item.disabled}
                      spinnerColor={item.spinnerColor}
                      iconPlacement={item?.iconPlacement}
                      iconComponent={
                        item.loading
                          ? null
                          : item.iconComponent
                      }
                      className={item.className}
                      style={item.style}
                      loading={item.loading}
                    />
                  ))
                  : null
              }
              <PopoverMenu
                id="quick_sale"
                menuOptions={[{
                  label: (
                    <Fragment>
                      <TickIcon width={20} height={18} id="tick_black_icon" />
                      <ParagraphText className="textCapitalizeFirstLetter">
                        {`${I18n.mark_as} ${I18n["accepted"]}`}
                      </ParagraphText>
                    </Fragment>
                  ),
                  action: (e) => {
                    e.stopPropagation();
                    onSelectOption(I18n.mark_as, {
                      name: "Accepted",
                      statusValue: "accepted"
                    });
                  },
                },]}
                popOverId="mark_as_id"
                popOverStyle={{
                  marginLeft: "0px",
                  borderRadius: "16px !important",
                }}
                popoverButtonClassName={styles.printButton}
                popoverButton={I18n.actions}
                disabled={Object.values(orderToDownload).length
                  ? false
                  : true}
                popoverButtonRestProps={{ iconRightSideComponent: <Box className="marginLeft5 marginTop5"><DownNewIcon /></Box> }}
                openPopoverClassName={styles.openPopoverClassName}
              />
            </Box>
          }
        />
        <Box display={"flex"} alignItems={"center"} padding={"12px 24px"} gap={"60px"}>
          {
            balance.length > 0 && balance.map(((item, i) => (<Box key={i} width={200} height={45}>
              <ParagraphText className={"newLightColor fontSize14"}>{item.title}</ParagraphText>
              <ParagraphText className={"newFontColor"}>{item.count}</ParagraphText>
            </Box>)))
          }
        </Box>
        {list?.length ? (
          <HeaderItem
            isOrderList={isOrderList}
            data={{ handleSelection, orderToDownload, list }}
            I18n={I18n}
          />
        ) : null}

        <Box
          className={`${"accountListBodyWarpper"} generic-scrollbar`}
          id="scrollableDiv"
        >
          {isOrderList ? (
            searchLoad ? (
              <Loader />
            ) : isAppliedFilter && !list?.length ? (
              <div className="orderLoaderMain width100">
                {isAppliedFilter && (
                  <Box className="h-100">
                    <FilterNonIdeal
                      title={I18n.no_order_matching_those_filters}
                      subTitle={I18n.try_adjusting_filters}
                      subTitleTextOnClick={() => resetFilters()}
                      subTitleText={I18n.reset_small}
                    />
                  </Box>
                )}
              </div>
            ) : list?.length ? (
              <AppPagination
                data={{
                  handleNext: () => {
                    const newOffSet = offset + 15;
                    setOffset(newOffSet);
                    handlePagination(newOffSet, 15, filters.keywords, { ...formattedDateFilter, order_status: filters?.status || undefined })
                  },
                  count: totalOrders,
                  pageLoad,
                  list,
                }}
              >
                {list.map((order, index) => (
                  <OrderListItem
                    data={{
                      handleOrderStatusList,
                      handleOrderStatus,
                      handleGetOrder,
                      rejectReasons,
                      updateLoad,
                      orderToDownload,
                      handleSelection,
                      order,
                      toggleChatWidget,
                      statusColor,
                      clearMarkedOrders,
                      index,
                      I18n,
                    }}
                  />
                ))}
              </AppPagination>
            ) : null
          ) : !isOrderList ? (
            returnLoad || searchLoad ? (
              <Loader />
            ) : isAppliedFilter && !list?.length ? (
              <Box className="h-100">
                <FilterNonIdeal
                  title={I18n.no_order_matching_those_filters}
                  subTitle={I18n.try_adjusting_filters}
                  subTitleTextOnClick={() => resetFilters()}
                  subTitleText={I18n.reset_small}
                />
              </Box>
            ) : list?.length ? (
              <AppPagination
                data={{
                  handleNext: handlePagination,
                  count: totalOrders,
                  pageLoad,
                  list,
                }}
              >
                {list.map((order, index) => (
                  <ReturnListItem
                    data={{
                      handleOrderStatus,
                      handleGetOrder,
                      updateLoad,
                      order,
                      index,
                      I18n,
                    }}
                  />
                ))}
              </AppPagination>
            ) : null
          ) : (
            <AppNonIdeal
              data={{
                subtitle: I18n.you_have_not_received_any_return,
                title: I18n.return_management,
                image: containerImage,
                I18n,
              }}
            />
          )}
        </Box>
      </Box>
    </>
  );
};

export default OrderList;
